import React from 'react'
import styled from 'styled-components'
import { ICapture, ISegment } from '../types'
import Imaging from '../utils/imaging'
import { getCaptureWatermarkPreviewStyles } from '../utils/utils'

const Container = styled.div`
    border-radius: inherit;
    overflow: hidden;
    position: relative;
`

const SegmentImage = styled.img`
    width: 100%;
    position: relative;
    display: block;
`

const SegmentVideo = styled.video`
    width: 100%;
    display: block;
    position: relative;
`

const Watermark = styled.img`
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    className?: string
    capture: ICapture
    segment: ISegment
    height: number
    width: number
    soundEnabled?: boolean
    showVideo?: boolean
    isPaused?: boolean
}

const SegmentPreview = ({
    className,
    capture,
    segment,
    width: previewWidth,
    height: previewHeight,
    showVideo = false,
    soundEnabled = false,
    isPaused = false,
}: Props) => {
    const { editParams } = segment
    const scaleX = editParams?.crop ? capture.width / editParams.crop.width : 1
    const scaleY = editParams?.crop ? capture.height / editParams.crop.height : 1
    const width = previewWidth * scaleX
    const height = previewHeight * scaleY
    const left = editParams?.crop ? -(editParams.crop.x / capture.width) * width : 0
    const top = editParams?.crop ? -(editParams.crop.y / capture.height) * height : 0
    const style = editParams?.crop
        ? {
              left,
              top,
              width,
              height,
          }
        : {}
    const startTime = editParams?.trim?.start || 0
    const endTime = editParams?.trim?.end || segment.duration
    let previewUrl = isPaused ? segment.thumb_url : segment.preview_url
    let videoUrl = segment.video_url

    // If this clip has been trimmed, we also trim the preview thumbnail.
    if (!isPaused && editParams && (startTime > 0 || endTime !== segment.duration)) {
        const duration = endTime - startTime
        const trimmedVideo = Imaging.trim(segment.video_url, startTime, duration)
        videoUrl = trimmedVideo
        previewUrl = Imaging.downsample(videoUrl, 5, 'gif', 250)
    }

    return (
        <Container className={className}>
            {showVideo && !isPaused ? (
                <SegmentVideo style={style} src={videoUrl} autoPlay={true} loop={true} muted={!soundEnabled} />
            ) : (
                <SegmentImage key={previewUrl} style={style} src={previewUrl} />
            )}
            {editParams?.watermark && <Watermark src={editParams.watermark} alt="" />}
            {capture.watermark &&
                capture.upload_metadata?.watermark_position &&
                capture.upload_metadata.watermark_width && (
                    <img
                        {...{
                            src: capture.watermark,
                            alt: '',
                            style: getCaptureWatermarkPreviewStyles(capture, segment, width / capture.width),
                        }}
                    />
                )}
        </Container>
    )
}

export default SegmentPreview
